import apiHandler from "../core/apiHandler";

const cashAdjustmentApi = apiHandler("cash/adjustments");

export default cashAdjustmentApi;